import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";
import { useAuthStore } from "../store/authStore";
import { formatInTz } from "../lib/dates";
import { Mail } from "lucide-react";

export default function EmailOutbox() {
  const { t } = useTranslation();
  const { tenant } = useAuthStore();
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/email-outbox");
      setItems(data);
    })();
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-zinc-500">
          {t("brand")}
        </div>
        <h1 className="mt-1 font-display text-3xl font-semibold tracking-tight text-zinc-950 sm:text-4xl">
          {t("nav.email_outbox")}
        </h1>
        <p className="mt-1 text-sm text-zinc-500">
          Mock outbox — no real emails are sent. All notifications land here.
        </p>
      </div>

      {items.length === 0 ? (
        <div className="rounded-lg border border-dashed border-zinc-300 bg-white p-12 text-center text-sm text-zinc-500">
          Empty
        </div>
      ) : (
        <ul className="divide-y divide-zinc-100 overflow-hidden rounded-lg border border-zinc-200 bg-white">
          {items.map((e) => (
            <li key={e.id} className="flex gap-4 p-5">
              <div className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-zinc-100">
                <Mail className="h-4 w-4 text-zinc-700" strokeWidth={1.75} />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-medium text-zinc-900">
                    {e.subject}
                  </div>
                  <div className="text-xs text-zinc-500">
                    {formatInTz(e.created_at, tenant?.timezone, "DD MMM HH:mm")}
                  </div>
                </div>
                <div className="mt-1 text-xs text-zinc-500">To: {e.to}</div>
                <div className="mt-2 whitespace-pre-wrap text-sm text-zinc-700">
                  {e.body}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
